import { Link } from "@tanstack/react-router";
import { buttonVariants } from "@workspace/web-ui/components/button";
import { Card, CardContent } from "@workspace/web-ui/components/card";
import { cn } from "@workspace/web-ui/lib/utils";

import paymentError from "~/assets/images/payment-error.svg";

export function MedicationPaymentError() {
   
    return (
      <div className="flex items-center justify-center bg-muted/50 px-4">
        <Card className=" w-auto rounded-xl shadow-xl">
          <CardContent className="p-6">
            <div className="flex flex-col items-center text-center">
              <div className="size-20 mb-3">
                <img src={paymentError} alt="payment-image" className="w-full" />
              </div>
              <h2 className="text-[40px] font-semibold">Payment Failed!</h2>
              <p className="text-sm flex text-center text-muted-foreground mt-1">
                We couldn&apos;t process your payment. This could be due to insufficient funds, incorrect card details, or a temporary issue with the payment processor.
              </p>
  
              <div className="w-full mt-6 text-sm p-4 rounded-[8px] bg-[#FEEBEB] text-left space-y-4">
                <p>Error: Your card was declined. Please check your card details or try a different payment method.</p>
              </div>
  
              <Link to="/dashboard/weight-loss/appointments" className={cn(buttonVariants({ variant: "default" }), "mt-6 w-full rounded-lg bg-[#4272DD]")}>Try again</Link>
            </div>
          </CardContent>
        </Card>
      </div>
    )
  }